module.exports = __webpack_public_path__ + "static/media/expired.7feee765.svg";